import { List } from 'antd'
import { FileImageOutlined } from '@ant-design/icons'
import { useState } from 'react'
import { Report } from '@cims-online/shared'
import { errorHandler } from 'hooks/errorHandler'
import { useConcreteTestSetTrackerContext } from '../../ConcreteTestSetTrackerContext'
import { CIMSModal } from 'components/CIMSModal'
import { CIMSModalWrapperProps } from 'components/CIMSModal/types'
import { useOptions } from 'components/CIMSSelect/hooks/useOptions'
import CIMSSelect from 'components/CIMSSelect'
import CIMSLink from 'components/CIMSLink'
import { useConcreteTestSetTrackerPdfModalQuery } from 'schema'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { useReportURLDependencies } from 'hooks/useReportURLDependencies'
import { ConcreteTestSet } from '../../ConcreteTestSetTrackerContext/types'

const PDFModal: React.FC<CIMSModalWrapperProps<ConcreteTestSet>> = ({
  visible,
  onClose,
  state,
}) => {
  const { refetch } = useConcreteTestSetTrackerContext()
  const [wasGenerated, setWasGenerated] = useState(false)
  const [selectedFiles, setSelectedFiles] = useState<string[]>([])
  const dependencies = useReportURLDependencies()
  const { globalId } = state ?? {}
  const { data, loading } = useConcreteTestSetTrackerPdfModalQuery({
    ...DefaultQueryHookOptions,
    skip: !globalId,
    variables: { globalId: globalId! },
  })

  const options = useOptions({
    items:
      data?.concreteTestSet?.sharePointResource?.sharePointResources?.filter(
        ({ id }) => id !== state?.packetSharePointResource?.id
      ),
    value: 'id',
    label: 'name',
    sort: 'name',
  })

  return (
    <CIMSModal
      title="Create Concrete Test Set Packet"
      visible={visible}
      onCancel={() => {
        setWasGenerated(false)
        setSelectedFiles([])
        onClose()
      }}
      disabled={!state || wasGenerated || loading}
      onOk={() => {
        if (!globalId) return errorHandler('Global id must be defined')
        try {
          const tab = window.open(
            Report.ConcreteTestSet.toURL({
              ...dependencies,
              globalId,
              driveItemIds: selectedFiles.length ? selectedFiles : undefined,
            })
          )
          setWasGenerated(true)
          if (tab) {
            tab.onbeforeunload = () => refetch()
          }
        } catch (err) {
          errorHandler(err)
        }
      }}
    >
      <List
        header="Currently Selected Files"
        itemLayout="horizontal"
        dataSource={data?.concreteTestSet?.sharePointResource?.sharePointResources.filter(
          ({ id }) => selectedFiles.includes(id)
        )}
        loading={loading}
        renderItem={(file) => {
          return (
            <List.Item>
              <List.Item.Meta
                avatar={<FileImageOutlined />}
                title={
                  file.webUrl ? (
                    <CIMSLink external href={file.webUrl}>
                      {file.name}
                    </CIMSLink>
                  ) : (
                    file.name
                  )
                }
              />
            </List.Item>
          )
        }}
      />
      <CIMSSelect
        simple
        mode="multiple"
        placeholder="Selected files are staged to be added to the generated pdf."
        onChange={(selectedValues) => {
          setSelectedFiles(selectedValues as string[])
        }}
        options={options}
        loading={loading}
        style={{ width: '100%' }}
      />
    </CIMSModal>
  )
}

export default PDFModal
